/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
import './fslightbox.js';


document.addEventListener('DOMContentLoaded', () => {
  // Busca todos los carruseles del bloque
  const carousels = document.querySelectorAll('.wp-block-lahormiga-blocks-images-carousel');

  carousels.forEach(block => {
    const track = block.querySelector('.track');
    const prev = block.querySelector('.prev');
    const next = block.querySelector('.next');
    if (!track) return;

    let index = 0;

    function update(dir) {
      const items = track.querySelectorAll('img').length;
      if (items === 0) return;
      const step = 1;
      if (dir === 'next') index = (index + step) % items;
      if (dir === 'prev') index = (index - step + items) % items;
      const w = track.querySelector('img').getBoundingClientRect().width + 12; // ancho + gap
      track.style.transform = `translateX(${-index * w}px)`;
    }

    if (prev) prev.addEventListener('click', () => update('prev'));
    if (next) next.addEventListener('click', () => update('next'));

    // Autoplay
    setInterval(() => update('next'), 2500);
  });
});


/* eslint-enable no-console */
